import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgFilter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      className="filter_svg__border"
      d="M9.5 11.395v1.59l-3 1.5v-3.09a4.5 4.5 0 0 0-.74-2.472L1.436 2.346a.5.5 0 0 1 .418-.775h12.292a.5.5 0 0 1 .418.775L10.24 8.923a4.5 4.5 0 0 0-.74 2.472Z"
      stroke="#4D4D4D"
    />
    <path
      className="filter_svg__filled"
      d="m12.673 4.818-9.106.919 2.936 4.577.221 3.756 2.462-1.136.474-3.41 3.013-4.706Z"
      fill="#4D4D4D"
    />
  </svg>
);
const Memo = memo(SvgFilter);
export default Memo;
